export const phoneLogServiceBaseUrl = "https://api.phonelog.warnerbros.com";
export const phoneLogSharedServiceBaseUrl = "";
export const OKTA_CLIENT_ID = "0oawc6jzwoJzKs03Z0x7";
export const OKTA_ISSUER_URL = "https://sso.wbd.com/oauth2/default";
export const OKTA_REDIRECT_URL = window.location.origin + "/callback";
export const OKTA_URL = "https://sso.wbd.com";
export const IDLE_TIMEOUT = "60";
export const IDLE_WARN_TIMEOUT = "30";
